module.exports = __webpack_public_path__ + "img/bg-login-old.71485afe.png";